import Tippy from '@tippyjs/react';
import { Colaboracao, FocoNoCliente, Inovacao, MandouBem, Resolutividade, Lideranca, Uau, Valeu } from 'components/icons';
import { differenceInDays, format } from 'date-fns';
import InputMask from 'react-input-mask';

import { UserAvatar } from 'components/user-avatar';
import { useAuth } from 'context/AuthContext';
import { FormEvent, useCallback, useEffect, useRef, useState } from 'react';
import { BiInfoCircle } from 'react-icons/bi';
import { FaHeart } from 'react-icons/fa';
import { MdModeComment } from 'react-icons/md';
import { registerInteraction } from 'services/interactions.service';
import { useModal } from 'context/ModalContext';
import { getKPIHistoryPag, getServerTime } from 'services/dashboard.service';
import Box from 'components/ui/box';
import ArticlePlaceholder from 'components/ui/article-placeholder';
import Button from 'components/ui/button';
import { TbMessageCancel, TbSearch } from 'react-icons/tb';
import { convertEmojis } from 'utils/helpers';
import Humanograma from 'components/Humanograma';
import { FiEdit3 } from 'react-icons/fi';
import { BsArrowReturnLeft } from 'react-icons/bs';
import ModalCancelRecognition from 'components/modal-cancel-recognition';
import ModalComment from 'components/modal-comment';

const iconSize = 30;
const Coins: any = {
  uau: (
    <div className="w-[30px]">
      <Uau size={iconSize} />
    </div>
  ),
  mandou: (
    <div className="w-[30px]">
      <MandouBem size={iconSize} />
    </div>
  ),
  valeu: (
    <div className="w-[30px]">
      <Valeu size={iconSize} />
    </div>
  ),
};

const CoinLabel: any = {
  uau: 'Arrasou',
  mandou: 'Top',
  valeu: 'Curti',
};

const Behaviors: any = {
  colaboracao: (
    <div className="w-[30px]">
      <Colaboracao size={iconSize} />
    </div>
  ),
  inovacao: (
    <div className="w-[30px]">
      <Inovacao size={iconSize} />
    </div>
  ),
  foco: (
    <div className="w-[30px]">
      <FocoNoCliente size={iconSize} />
    </div>
  ),
  resolutividade: (
    <div className="w-[30px]">
      <Resolutividade size={iconSize} />
    </div>
  ),
  lideranca: (
    <div className="w-[30px]">
      <Lideranca size={iconSize} />
    </div>
  ),
};

const BehaviorLabel: any = {
  colaboracao: 'Colaboração',
  inovacao: 'Inovação',
  foco: 'Foco no Cliente',
  resolutividade: 'Proatividade',
  lideranca: 'Liderança Engajadora',
};

// const likeTippy = function (data: any) {
//   return (
//     <div>
//       <p>
//         Curtidas:{' '}
//         {data?.interaction?.length
//           ? data.interaction?.filter((item: any) => item.like)?.length
//           : 0}
//       </p>

//       {data.interaction
//         ?.filter((item: any) => item.like)
//         .map((item: any) => (
//           <p key={item._id}>{item.senderName}</p>
//         ))}
//     </div>
//   );
// };

interface Props {
  filter?: any;
}

export default function RecognitionReceived(data: Props) {
  const { filter } = data;
  const { user, currentCycle } = useAuth();
  const [list, setList] = useState<any[]>([]);
  const { showModal } = useModal();
  const [loadingList, setLoadingList] = useState(true);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [load, setLoad] = useState(false);
  const searchRef = useRef<any>();
  const [currentFilter, setCurrentFilter] = useState({});
  const [time, setTime] = useState<number>();
  const [returnRecognitionId, setReturnRecognitionId] = useState<string | undefined>();

  const [modalCommentObj, setModalCommentObj] = useState<any>();
  const [loadingInteraction, setLoadingInteraction] = useState<boolean | undefined>(false);

  useEffect(() => {
    // console.log(filter);
    setCurrentFilter(filter);
  }, [filter]);

  useEffect(() => {
    async function loadTime() {
      const res = await getServerTime();
      setTime(res);
    }

    if (!!user && !!currentCycle) {
      loadTime();
    }
  }, [currentCycle, user]);

  const hasLike = useCallback(
    (item: any) => {
      return !!item?.interaction?.find((i: any) => i.sender === user?._id && !!i.like);
    },
    [user?._id],
  );

  function canEdit(item: any) {
    if (!!item && !!time) {
      const differenceTime = differenceInDays(new Date(time), new Date(item.created));

      return differenceTime <= 10;
    }

    return false;
  }

  const sendInteraction = useCallback(
    async (item: any, type: string, message?: string) => {
      setLoadingInteraction(true);
      const index = list.findIndex((i: any) => i._id === item._id);

      let payload: any;
      const newList = [...list];
      const interactionItem = item.interaction[0];

      if (!item?.interaction?.length && item?.action_id) {
        payload = {
          item: item.action_id as string,
          player: item.sender as string,
          sender: user?._id as string,
          senderName: user?.name as string,
          like: type === 'like' && hasLike(item) ? false : type === 'like' && !hasLike(item) ? true : hasLike(item),
          message: type === 'message' && typeof message === 'string' && message.trim().length ? message.trim() : undefined,
          created: {
            $date: new Date().getTime(),
          },
        };
      } else if (!!item?.interaction?.length && item?.action_id && !!interactionItem?._id) {
        if (type === 'like') {
          payload = {
            ...interactionItem,
            like: !hasLike(item),
            updated: {
              $date: new Date().getTime(),
            },
          };
        } else if (type === 'message') {
          payload = {
            ...interactionItem,
            message,
            updated: {
              $date: new Date().getTime(),
            },
          };
        }

        if (typeof payload?.created === 'number') {
          payload.created = {
            $date: payload.created,
          };
        }
      }

      if (!!payload && !!payload.created) {
        const data = await registerInteraction(payload);

        if (!!newList[index]?.interaction?.length) {
          newList[index].interaction[0] = data;
        } else {
          newList[index].interaction = [data]; /// bug aki
        }

        setList(newList);
      }

      setLoadingInteraction(false);
    },
    [hasLike, list, user?._id, user?.name],
  );

  function getComment(item: any) {
    const interaction = item.interaction?.find((e: any) => !!e.message?.trim().length);

    if (interaction) {
      return interaction;
    } else {
      return null;
    }
  }

  function removeFromList(id: string) {
    setList(list.filter(x => x.action_id !== id));
  }

  function handleDetail(item: any) {
    showModal('extrato-detalhe', item);
  }

  function getReturnComment(item: any) {
    if (!!item?.cancelled && !!item?.returnRecognition?.message) {
      return item?.returnRecognition?.message;
    }

    return null;
  }

  const isOldVersion = (item: any): boolean => {
    return !!item.proximidade && !!item.hierarquia && !!item.total;
  };

  useEffect(() => {
    async function loadData() {
      setLoadingList(true);
      const rangeItem = page ? page * 5 : 0;

      if (page) setLoad(true);
      // console.log(cycleId);
      // console.log(currentFilter);

      const data = await getKPIHistoryPag(
        user?._id,
        currentFilter,
        rangeItem,
        5,
        currentCycle?.date_start,
        currentCycle?.date_finish,
      );
      setList(page ? [...list, ...data.result] : data.result);
      setTotal(data.range.total);
      setTotalPage(data.range.pages);

      setLoadingList(false);
      setLoad(false);
    }

    if (!!user && !!currentCycle) {
      loadData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCycle, user, page, currentFilter]);

  const onSearch = (e: FormEvent) => {
    // console.log(searchRef.current.value);
    setCurrentFilter({
      ...currentFilter,
      ...{ search: searchRef.current.value },
    });

    e.preventDefault();
    // console.log(searchRef.current.value);
  };

  return (
    <>
      <div className="flex flex-col items-start justify-start lg:flex-row lg:justify-between lg:items-center mb-8">
        <h3 className="text-white font-bold text-xl mb-4 lg:mb-0" tabIndex={0}>
          Reconhecimentos recebidos
          <span className="text-xl lg:text-2xl font-bold text-yellow ">{total ? ` (${total})` : null}</span>
        </h3>
        <div className="flex flex-row items-center space-x-4">
          <form onSubmit={onSearch} className="pl-1 -ml-1 flex-1 flex space-x-5">
            <InputMask
              placeholder="Pesquise com nome ou e-mail"
              alwaysShowMask={false}
              mask={''}
              ref={(ref: any) => (searchRef.current = ref)}
              inputMode="search"
              style={{ fontSize: 16 }}
              className="min-w-full lg:min-w-[416px] bg-maastricht-blue text-sm text-white font-thin flex-1 rounded-md py-2 px-4"
            />
            <button type="submit">
              <TbSearch size={28} className="cursor-pointer hover:ring-2 mr-1 rounded-full" />
            </button>
          </form>
        </div>
      </div>

      <Box className="relative bg-oxford-blue border-electric-blue lg:p-6 flex flex-col justify-center items-center border-opacity-100 bg-opacity-100">
        {loadingList && (
          <div className="space-y-2 w-full">
            <ArticlePlaceholder />
            <ArticlePlaceholder />
          </div>
        )}

        {!loadingList && (
          <div className="space-y-2 w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {!!list?.length &&
                list?.map((item: any) => (
                  <div className="bg-maastricht-blue-3 rounded-xl text-gray-300 space-y-2 py-6 px-6 lg:px-8" key={item?._id}>
                    <div className="flex flex-col lg:flex-col items-start lg:items-start mb-5">
                      <div className="flex-1 flex flex-col-reverse lg:flex-row items-start space-x-2 leading-tight w-full">
                        <div className="flex flex-1 w-full items-start">
                          <div className="mr-2 w-11">
                            <UserAvatar data={item.sender_avatar} />
                          </div>
                          <div className="flex-1 w-full block">
                            <Humanograma
                              data={{
                                ...item,
                                nome: item.sender_name,
                                funcao: item.sender_funcao,
                                _id: item.sender,
                              }}
                            >
                              <div className="flex items-center">
                                <p className="flex flex-row items-center text-sm lg:text-base text-alice-blue font-semibold hover:cursor-pointer hover:underline">
                                  {item.sender_nome_guerra || item.sender_name.split(' ')[0]}{' '}
                                  <span className="font-thin ml-1">({item.sender})</span>
                                  <BiInfoCircle className="hidden lg:block relative ml-1" />
                                </p>
                                {!item.cancelled && (
                                  <>
                                    <span className="hidden lg:block whitespace-nowrap font-thin text-sm lg:text-base text-alice-blue ml-1">
                                      enviou:
                                    </span>
                                    <span className="lg:hidden font-thin text-sm lg:text-base text-alice-blue ml-1">enviou:</span>
                                  </>
                                )}
                              </div>
                            </Humanograma>

                            <div className="block 2xl:flex flex-col 2xl:flex-row 2xl:items-center w-full space-y-2 2xl:space-y-0 2xl:space-x-2 mt-1">
                              {!!item.cancelled ? (
                                <div className="inline-flex flex-row items-center space-x-2 px-3 py-1 text-[#ED2B48] bg-oxford-blue rounded-full">
                                  <TbMessageCancel size={16} />
                                  <span className="text-xs whitespace-nowrap">Reconhecimento cancelado pelo autor</span>
                                </div>
                              ) : (
                                <>
                                  <div
                                    className="inline-flex flex-row items-center space-x-2 px-3 py-1 text-yellow bg-oxford-blue rounded-full"
                                    tabIndex={0}
                                  >
                                    {Coins[item.coin]} <span className="text-xs">{CoinLabel[item.coin]}</span>
                                  </div>
                                  <br className="block 2xl:hidden" />
                                  <div
                                    className={`inline-flex flex-row items-center space-x-2 px-3 py-1 text-yellow bg-oxford-blue rounded-full ${
                                      item.behavior === 'foco' ? 'min-w-[142px]' : ''
                                    }`}
                                    tabIndex={0}
                                  >
                                    {Behaviors[item.behavior]} <span className="text-xs">{BehaviorLabel[item.behavior]}</span>
                                  </div>
                                  <br className="block 2xl:hidden" />
                                  <div className="inline-flex items-center space-x-2">
                                    <div
                                      onClick={() => (isOldVersion(item) ? handleDetail(item) : null)}
                                      className={`ring-white whitespace-nowrap 2xl:mt-0 flex-1 2xl:flex-none inline-flex flex-row items-center space-x-2 px-2 bg-oxford-blue py-1 text-electric-blue rounded-full ${
                                        isOldVersion(item) ? 'cursor-pointer hover:ring-2' : ''
                                      }`}
                                      tabIndex={0}
                                      aria-label={`total = ${item.total} pontos`}
                                    >
                                      <span>total = {item.total} pontos</span>{' '}
                                    </div>

                                    {isOldVersion(item) ? (
                                      <div>
                                        <BiInfoCircle size={20} />
                                      </div>
                                    ) : null}
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>

                        <div className="text-gray-400 text-xs leading-none flex justify-end w-full my-3 lg:my-0">
                          <span>{format(new Date(item.time), 'dd MMM yyyy | HH:mm')}</span>
                        </div>
                      </div>

                      {/* <div className="flex flex-col lg:flex-row flex-wrap lg:items-center w-full space-y-3 lg:space-y-0 lg:space-x-2 lg:ml-14 mt-4 lg:-mt-4">
                      <div className="w-1/2 lg:w-auto pr-1 lg:pr-0">
                        <div className="flex flex-row items-center space-x-2 px-2 text-yellow py-1 bg-oxford-blue rounded-full">
                          {Coins[item.coin]} <span className="text-xs">{CoinLabel[item.coin]}</span>
                        </div>
                      </div>
                      <div className="w-1/2 lg:w-auto lg:pl-0">
                        <div className="flex flex-row items-center space-x-2 px-2 bg-oxford-blue py-1 text-yellow rounded-full">
                          {Behaviors[item.behavior]} <span className="text-xs">{BehaviorLabel[item.behavior]}</span>
                        </div>
                      </div>
                      <div className="w-1/2 flex items-center space-x-2">
                        <div onClick={() => handleDetail(item)} className="cursor-pointer hover:ring-2 ring-white whitespace-nowrap lg:mt-0 flex-1 lg:flex-none flex flex-row items-center space-x-2 px-2 bg-oxford-blue py-1 text-electric-blue rounded-full">
                          <span>total = {item.total} pts</span>{' '}
                        </div>

                        <div>
                          <BiInfoCircle size={20} />
                        </div>
                      </div>
                    </div> */}
                    </div>

                    <hr className="border-prussian-blue" />

                    {!!item.message && (
                      <>
                        <div className="p-2 flex-1 flex-col" tabIndex={0}>
                          <p className="text-electric-blue font-thin">Reconhecimento recebido:</p>
                          <div className="text-alice-blue" dangerouslySetInnerHTML={{ __html: convertEmojis(item.message) }} />
                        </div>

                        {!!getComment(item) && (
                          <div className="p-2 flex-1 flex-col">
                            <div className="flex justify-between">
                              <p className="text-electric-blue font-thin">Comentário:</p>
                              {canEdit(getComment(item)) && (
                                <button
                                  onClick={() => {
                                    if (loadingInteraction) return;

                                    setModalCommentObj({
                                      ...item,
                                      message: getComment(item).message,
                                    });
                                  }}
                                  className={`flex items-center cursor-pointer text-electric-blue ${
                                    loadingInteraction ? '!cursor-wait' : ''
                                  }`}
                                  disabled={loadingInteraction}
                                >
                                  <FiEdit3 size={20} className="mr-2" /> Editar
                                </button>
                              )}
                            </div>
                            <div
                              className="text-alice-blue"
                              dangerouslySetInnerHTML={{
                                __html: convertEmojis(getComment(item).message),
                              }}
                            ></div>
                          </div>
                        )}
                      </>
                    )}

                    {!!getReturnComment(item) && (
                      <div className="p-2 flex-1 flex-col">
                        <p className="text-electric-blue font-thin">Motivo do cancelamento:</p>
                        <div
                          className="text-alice-blue"
                          dangerouslySetInnerHTML={{
                            __html: convertEmojis(getReturnComment(item)),
                          }}
                        ></div>
                      </div>
                    )}

                    {!item.cancelled && (
                      <div className="flex justify-end space-x-6">
                        {!!item.canReverseRecognition && (
                          <button
                            className={`flex items-center uppercase text-[#ED2B48]`}
                            onClick={() => setReturnRecognitionId(item.action_id)}
                          >
                            <BsArrowReturnLeft size={20} className="mr-2" />
                            Devolver para remetente
                          </button>
                        )}

                        <button
                          className={`flex items-center uppercase ${hasLike(item) ? 'text-electric-blue' : 'text-grey-dark'} ${
                            loadingInteraction ? '!cursor-wait' : ''
                          }`}
                          onClick={() => {
                            if (loadingInteraction) return;
                            sendInteraction(item, 'like');
                          }}
                          disabled={loadingInteraction}
                        >
                          <FaHeart size={20} className="mr-2" />
                          {hasLike(item) ? 'Curtido' : 'Curtir'}
                        </button>

                        {!getComment(item) && (
                          <button
                            className={`flex items-center uppercase text-grey-dark ${loadingInteraction ? '!cursor-wait' : ''}`}
                            onClick={() => {
                              if (loadingInteraction) return;
                              setModalCommentObj({ ...item, message: '' });
                            }}
                            disabled={loadingInteraction}
                          >
                            <MdModeComment size={20} className="mr-2" />
                            Comentar
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                ))}

              {!list?.length && (
                <>
                  <p className="text-white text-base text-center font-light leading-none block py-6">
                    Nenhum reconhecimento recebido até o momento.
                  </p>
                </>
              )}
            </div>

            {page + 1 < totalPage && (
              <div className="w-full flex justify-center mt-8">
                <Button disabled={load} className="px-4 py-2 mx-auto" type="button" onClick={() => setPage(page + 1)}>
                  {load ? 'Carregando...' : 'Carregar mais'}
                </Button>
              </div>
            )}
          </div>
        )}
      </Box>

      {!!returnRecognitionId && (
        <ModalCancelRecognition
          callback={function (action: string): void {
            if (action === 'remove') {
              // removeFromList(returnRecognitionId);
              setPage(0);
              setCurrentFilter({});
            } else if (action === 'close') {
              setReturnRecognitionId(undefined);
            }
          }}
          id={returnRecognitionId}
          type="return"
        />
      )}

      {!!modalCommentObj?._id && (
        <ModalComment
          close={() => setModalCommentObj(undefined)}
          message={modalCommentObj.message}
          sendMessage={(message, item) => {
            sendInteraction(item, 'message', message);
            setModalCommentObj(undefined);
          }}
          modalCommentObj={modalCommentObj}
        />
      )}
    </>
  );
}
